module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "blog"
  }, [_vm._m(0), _c('div', {
    staticClass: "blog__container"
  }, _vm._l((_vm.props), function(blog, i) {
    return (blog.acf.title) ? _c('router-link', {
      key: i,
      staticClass: "blog__blog-item",
      class: {
        'blog__blog-item--alt': i % 2
      },
      attrs: {
        "to": "/blog/" + blog.slug
      }
    }, [_c('div', {
      staticClass: "blog__blog-image",
      style: ({
        backgroundImage: 'url(' + blog.acf.hero + ')'
      })
    }), _c('div', {
      staticClass: "blog__blog-text-box"
    }, [_c('div', {
      staticClass: "blog__blog-title",
      domProps: {
        "innerHTML": _vm._s(blog.acf.title)
      }
    }), _c('div', {
      staticClass: "blog__blog-sub-title",
      domProps: {
        "innerHTML": _vm._s(blog.acf.sub_title)
      }
    })])]) : _vm._e()
  }))]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title"
  }, [_c('h1', [_vm._v("Check Out Our Latest Updates")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-406dc8a6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/blog/blog.pug
// module id = 1114
// module chunks = 1